'use strict'
import { PDFDocument } from 'pdf-lib'
import { axios, getErrorMessage } from '../helpers/axioshelper'

export default {
  updateTestSuiteExpireDate(testSuiteId, expireDate) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/testsuites/${testSuiteId}`, { expireDate: expireDate })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  saveTestSuite(testsuite) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/testsuites', testsuite)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getTests(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/testsuites/user/${userId}/tests`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteTest(userId, testId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/testsuites/user/${userId}/tests/${testId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getPdfRequirements(userId, testId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/testsuites/user/${userId}/tests/${testId}/pdfrequirements`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getPdfRequirementsTeamProfile(userId, testIds) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/testsuites/user/${userId}/tests/pdfrequirements`, { testIds: testIds })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  // pdfsToMerge: ArrayBuffer[]
  async mergePdfs(pdfsToMerge) {
    const mergedPdf = await PDFDocument.create()

    const createInnerPromise = async(arrayBuffer) => {
      const pdf = await PDFDocument.load(arrayBuffer)
      const indices = pdf.getPageIndices()
      // Remove front page if there are more pages in this pdf.
      if (indices.length > 1) {
        indices.shift()
      }
      return mergedPdf.copyPages(pdf, indices)
    }

    const outerPromise = pdfsToMerge.map((arrayBuffer) => {
      const innerPromise = createInnerPromise(arrayBuffer)
      return innerPromise
    })

    const resultOuterPromise = await Promise.all(outerPromise)
    resultOuterPromise.forEach((pageArray) => {
      pageArray.forEach((page, i) => {
        mergedPdf.addPage(page)
      })
    })
    return mergedPdf.save()
  },
  generatePdf(pdfSettings) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/testsuites/user/${pdfSettings.userId}/tests/${
            pdfSettings.testId
          }/generatePdf?languageId=${pdfSettings.languageId}&reportId=${
            pdfSettings.reportId
          }&normGroupId=${pdfSettings.normGroupId}&isPreviewMode=${
            pdfSettings.isPreviewMode
          }&isExpertReport=${pdfSettings.isExpertReport}`,
          {
            responseType: 'blob'
          }
        )
        .then(response => {
          const blob = new Blob([response.data])
          if (pdfSettings.frontPage) {
            new Response(blob).arrayBuffer().then(async(arrayBuffer) => {
              const pdfsToMerge = [pdfSettings.frontPage, arrayBuffer]
              const mergedPdfFile = await this.mergePdfs(pdfsToMerge)
              const url = window.URL.createObjectURL(new Blob([mergedPdfFile]))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'file.pdf')
              document.body.appendChild(link)
              link.click()
            })
          } else {
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'file.pdf')
            document.body.appendChild(link)
            link.click()
          }
          resolve(true)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  generateMultiPdf(pdfSettings) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/api/testsuites/generatemultipdf`, pdfSettings,
          {
            responseType: 'blob'
          }
        )
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'file.pdf')
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getTeamReportData(payload) {
    const body = {
      languageId: payload.languageId,
      normGroupId: payload.normGroupId,
      tests: payload.tests,
      reportId: payload.reportId
    }
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/v2/testsuites/user/${payload.userId}/teamreport/lsi`, body)
        .then(response => {
          const data = (response && response.data) || {}
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}
